import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { setWebTitle } from "@/lib/format-utils";
import InventoryListWithFilters from "../components/inventory-list";
import InventoryItemModal from "@/components/inventory/inventory-item-modal";
import { InventoryItem } from "@turizi/shared";

export default function InventoryPage(): JSX.Element {
    const { t } = useTranslation();

    setWebTitle(t("inventory_items"));

    // Modal state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState<InventoryItem | null>(null);
    const [parentItemForChild, setParentItemForChild] = useState<InventoryItem | null>(null);

    const handleCreateRoot = () => {
        setItemToEdit(null);
        setParentItemForChild(null);
        setIsModalOpen(true);
    };

    const handleEditItem = (item: InventoryItem) => {
        setItemToEdit(item);
        setParentItemForChild(null);
        setIsModalOpen(true);
    };

    const handleCreateChild = (parent: InventoryItem) => {
        setItemToEdit(null);
        setParentItemForChild(parent);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setItemToEdit(null);
        setParentItemForChild(null);
    };

    return (
        <div>
            <div className="panel-content space-y-6">
                {/* Header Action Banner */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-4 border-b border-gray-200/60">
                    <div>
                        <h1 className="text-xl font-bold text-gray-800">{t("inventory_items")}</h1>
                        <p className="text-xs text-gray-400 mt-1">
                            {t("inventory_page_description", "Manage inventory assets, vehicles, equipment, and their nested sub-items.")}
                        </p>
                    </div>
                    <Button
                        onClick={handleCreateRoot}
                        leftSection={<IconPlus size={16} />}
                        color="black"
                        radius="md"
                        className="font-bold w-fit"
                    >
                        {t("new_inventory_item")}
                    </Button>
                </div>

                {/* Filterable Tree List */}
                <InventoryListWithFilters
                    saving={false}
                    onEditItem={handleEditItem}
                    onCreateChild={handleCreateChild}
                />
            </div>

            {/* Reusable Form Modal */}
            <InventoryItemModal
                opened={isModalOpen}
                onClose={handleCloseModal}
                itemToEdit={itemToEdit}
                parentItemForChild={parentItemForChild}
            />
        </div>
    );
}